<template>
  <div>
    <custom-actions :panel="!orderId" :show-back="!!orderId">
      <template #header>
        <el-button v-if="hasDateSetting" type="primary" @click="showDateSetting">提货日期配置</el-button>
        <el-button v-if="hasExport" type="primary" @click="onDownExcel">导出</el-button>
        <el-button v-if="hasAdd" type="primary" @click="showAdd">新增提货订单</el-button>
      </template>
      <el-form v-if="!orderId" :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="供应商名称" prop="supplierName">
          <!-- <el-select
            clearable
            filterable
            v-model="searchForm.userId"
            placeholder="请选择客户名称"
          >
            <el-option
              v-for="(item, index) of userList"
              :value="item.userId"
              :label="item.userName"
              :key="index"
            ></el-option>
          </el-select> -->
          <el-input clearable v-model.trim="searchForm.supplierName" placeholder="请输入供应商名称" />
        </el-form-item>
        <el-form-item label="提货编号" prop="pickupNumber">
          <el-input clearable v-model="searchForm.pickupNumber" placeholder="请输入提货编号" />
        </el-form-item>
        <el-form-item label="司机姓名" prop="driverName">
          <el-input clearable v-model="searchForm.driverName" placeholder="请输入司机姓名" />
        </el-form-item>
        <el-form-item label="所属仓库" prop='warehouseId'>
          <el-select v-model="searchForm.warehouseId" :filterable="true" :clearable="true">
            <el-option :label="item.warehouseName" :value="item.warehouseId" v-for="item in warehouseList"
              :key="item.warehouseId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商品名称" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="保证金类型" prop="orderDepositType">
          <el-select clearable filterable v-model="searchForm.orderDepositType" placeholder="请选择保证金类型">
            <el-option v-for="(item, index) of orderDepositTypeList" :value="item.value" :label="item.label"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="提货状态" prop="pickupStatus">
          <el-select clearable filterable v-model="searchForm.pickupStatus" placeholder="请选择提货状态">
            <template  v-for="(item, index) of Array.from(pickupStatusMap)">
              <el-option v-if="item[0] !== '6'" :value="item[0]" :label="item[1]"
                         :key="index"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="提货日期" prop="dateArr">
          <el-date-picker v-model="dateArr" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="160" show-overflow-tooltip label="采购方" prop="userName"></el-table-column>
        <el-table-column min-width="160" show-overflow-tooltip label="供应商名称" prop="supplierName"></el-table-column>
        <el-table-column min-width="140" label="提货编号" prop="pickupNumber"></el-table-column>
        <el-table-column min-width="150" label="订单编号" prop="orderNumber"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip label="合同号" prop="contractNo"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="提货日期"
                         prop="vehicleDateStart"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="提货库点"
          prop="vehicleEndAddress"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="入库库点"
          prop="vehicleStartAddressName"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="车/船号"
          prop="vehicleKey"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="司机姓名"
          prop="driverName"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="是否预约"
          prop="isVehicle">
          <template v-slot="{ row }">
            {{ row.isVehicle === '1' ? "需要预约" : row.isVehicle === '2' ? "不需要预约" : "" }}
          </template>
        </el-table-column>

        <el-table-column min-width="100" label="计划数量" prop="planQuantity">
          <template v-slot="{ row }">
            {{ (row.planQuantity || 0) + row.specUnit }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="发货数量" prop="pickupQuantity">
          <template v-slot="{ row }">
            {{ (row.pickupQuantity || 0) + row.specUnit }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="实收数量" prop="arrivalQuantity">
          <template v-slot="{ row }">
            {{ (row.arrivalQuantity || 0) + row.specUnit }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="采购单价(元)" prop="pickupPrice"></el-table-column>
        <el-table-column min-width="120" label="提货单价(元)" prop="pickupPrice"></el-table-column>
        <el-table-column min-width="140" label="提货总价(元)" prop="totalAmount"></el-table-column>
        <el-table-column min-width="140" label="保证金类型" prop="orderDepositType">
          <template v-slot="{ row }">
            {{ orderDepositTypeMap.get(row.orderDepositType) }}
          </template>
        </el-table-column>

        <el-table-column min-width="120" label="保证金比例" prop="orderDeposit">
          <template v-slot="{ row }">
            {{ row.orderDeposit }}{{ row.orderDepositType && row.orderDepositType === '2' ? (row.specUnit ? '/' + row.specUnit : '') : '%' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="保证金抵用" prop="isDepositAmount">
          <template v-slot="{ row }">
            {{ row.isDepositAmount === '1' ? "是" : "否" }}
          </template>
        </el-table-column>
<!--        <el-table-column min-width="120" label="销售单价(元)" prop="specPrice"></el-table-column>-->
<!--        <el-table-column min-width="120" label="销售总价(元)" prop="specAllPrice"></el-table-column>-->
<!--        <el-table-column min-width="160" label="其他费用(运费等)" prop="otherFees">-->
<!--          <template v-slot="{ row }">-->
<!--            {{ row.otherFees }}<span v-if="row.remark">({{ row.remark }})</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column min-width="160" label="释放保证金" prop="releasedDepositDeposit"></el-table-column>-->
        <!-- <el-table-column min-width="200" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="160" label="释放保证金总额(元)" prop="releasedDepositAmount"></el-table-column>
        <el-table-column min-width="160" label="保证金抵扣货款" prop="isDepositAmount">
          <template v-slot="{ row }">
            <el-tag type="success" v-if="row.isDepositAmount == '1'">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column min-width="180" label="释放保证金(充值)(元)" prop="depositAmount"></el-table-column> -->
        <!-- <el-table-column min-width="180" label="释放保证金(收益)(元)" prop="pickupAmount"></el-table-column> -->
        <el-table-column min-width="150" label="提货状态" prop="pickupStatus">
          <template v-slot="{ row }">
            <el-tag v-if="row.pickupStatus == '1'">业务员审核</el-tag>
            <el-tag v-if="row.pickupStatus == '2'">业务经理审核</el-tag>
            <el-tag type="success" v-if="row.pickupStatus == '3'">已完成</el-tag>
            <el-tag type="danger" v-if="row.pickupStatus == '4'">流程驳回</el-tag>
            <template v-if="row.pickupStatus == '5'">
              <el-tag v-if="row.isVehicle === '2'" type="warning">业务员确认中</el-tag>
              <el-tag v-else type="warning">车辆装运中({{ reservationStatusMap.get(row.reservationStatus) }})</el-tag>
            </template>
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="140" label="创建时间" prop="ctime"></el-table-column> -->

        <el-table-column width="220" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/ycdeliveryOrder/detail?pickupId=' + row.pickupId)">详情</el-button>
            <el-button type="text" v-if="row.pickupStatus == 1 && hasApproval1" @click="onAppoval(row)">审批</el-button>
            <el-button type="text" v-if="row.pickupStatus != '3' && hasEdit" @click="onEdit(row)">编辑</el-button>
            <el-button type="text" v-if="row.pickupStatus === '3' && hasCompleteEdit"
              @click="onEdit(row)">编辑</el-button>
            <el-button type="text" v-if="row.pickupStatus == 2 && hasApproval2" @click="onAppoval(row)">审批</el-button>
            <el-button type="text" v-if="row.pickupId" @click="onDown(row.pickupId)">下载</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.pickupId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- 提货日期配置 -->
    <el-dialog title="提货日期配置" class="global-dialog" :visible.sync="showSettingVisible" width="50%">
      <el-form style="padding-top: 20px;" label-width="120px" :model="dateSettingForm" :rules="settingRules"
        ref="dateSettingForm">
        <el-form-item label="仓库性质" prop="warehouseType">
          <el-radio-group v-model="dateSettingForm.warehouseType"
            @input="val => setSettingForm(val, dateSettingForm.isBulkOil)">
            <el-radio label="1">内库</el-radio>
            <el-radio label="2">外库</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否散油" prop="isBulkOil">
          <el-radio-group v-model="dateSettingForm.isBulkOil"
            @input="val => setSettingForm(dateSettingForm.warehouseType, val)">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提货日期" prop="wkDate">
          <el-checkbox-group v-model="dateSettingForm.wkDate">
            <el-checkbox label="1">周一</el-checkbox>
            <el-checkbox label="2">周二</el-checkbox>
            <el-checkbox label="3">周三</el-checkbox>
            <el-checkbox label="4">周四</el-checkbox>
            <el-checkbox label="5">周五</el-checkbox>
            <el-checkbox label="6">周六</el-checkbox>
            <el-checkbox label="7">周日</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="primary" @click="saveSetting">保存</el-button>
        <el-button @click="showSettingVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 审批 -->
    <ApprovalDialog urlType="3" :vehicle="currentPickupStatus === '1'" :relatedId="rowId" v-if="showDlg"
      @closeDlg="showDlg = false" @successSave="loadData" :showDlg="showDlg"></ApprovalDialog>

    <DeliveryCarEditDlg :pickupId="rowId" v-if="showEditDlg" @closeDlg="showEditDlg = false" @saveSuccess="loadData"
      :showDlg="showEditDlg"></DeliveryCarEditDlg>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import ApprovalDialog from '@/views/zhyc/bondRecord/ApprovalDialog'
import DeliveryCarEditDlg from './DeliveryCarEditDlg'
import { pickupStatus, reservationStatus, orderDepositType } from '@/utils/dict'
import { deepClone, mapToObjectArray } from '@/utils/utils'
import { downloadPickupPdf } from '@/utils/pickupPdf'

export default {
  name: 'deliveryOrder',
  mixins: [keepAlive],
  components: { ApprovalDialog, DeliveryCarEditDlg },
  data() {
    return {
      showSettingVisible: false,
      tableData: [],
      pickupStatusMap: pickupStatus,
      reservationStatusMap: reservationStatus,
      orderDepositTypeMap: orderDepositType,
      orderDepositTypeList: mapToObjectArray(orderDepositType),
      page: 1,
      total: 0,
      loading: false,
      settingList: [],
      dateSettingForm: {
        warehouseType: '1', // 仓库性质1内库2外库
        wkDate: [], // 允许提货日期(周)多个用,隔开
        isBulkOil: '1' // 是否散油，0表示不是，1表示是
      },
      settingRules: {
        warehouseType: [{ required: true, message: '请选择仓库性质' }],
        wkDate: [{ required: true, message: '请选择提货日期' }],
        isBulkOil: [{ required: true, message: '请选择是否散油' }]
      },
      warehouseList: [],
      searchForm: {
        userId: '',
        warehouseId: '',
        supplierName: '',
        pickupNumber: '',
        driverName: '',
        pickupStatus: '',
        specName: '',
        orderDepositType: ''
      },
      dateArr: [],

      userList: [],
      showDlg: false,
      rowId: '',
      currentPickupStatus: '',
      showEditDlg: false
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    userInfo() {
      return this.$store.state.user
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasCompleteEdit() {
      return this.buttonList.includes('completeedit')
    },
    hasDateSetting() {
      return this.buttonList.includes('dateSetting')
    },
    hasApproval2() {
      return this.buttonList.includes('cwapproval') && this.userInfo.isLeader === '1'
    },
    hasApproval1() {
      return this.buttonList.includes('approval')
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    orderId() {
      return this.$route.query.orderId
    },
    orderType() {
      return this.$route.query.orderType
    }
  },
  created() {
    this.loadUser()
    this.loadData()
    this.loadWarehouseList()
  },
  watch: {
    orderType(newV, oldV) {
      if (newV && oldV && newV !== oldV) {
        this.onReset()
        this.onSearch()
      }
    }
  },

  methods: {
    loadWarehouseList() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.warehouseList = res.list || []
      })
    },
    showDateSetting() {
      this.showSettingVisible = true
      this.$axios.get(this.$apis.deliveryOrder.selectLyWarConfByList).then(res => {
        res.list.forEach(item => {
          item.wkDate = item.wkDate ? item.wkDate.split(',') : []
        })
        this.settingList = res.list || []
        this.setSettingForm(this.dateSettingForm.warehouseType, this.dateSettingForm.isBulkOil)
      })
    },
    setSettingForm(warehouseType, isBulkOil) {
      console.log('warehouseType', warehouseType)
      console.log('isBulkOil', isBulkOil)
      const formData = this.settingList.find(item => item.warehouseType === warehouseType && item.isBulkOil === isBulkOil)
      this.dateSettingForm = deepClone(formData)
    },
    saveSetting() {
      this.$refs.dateSettingForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.deliveryOrder.updateLyWarConf, {
            warehouseType: this.dateSettingForm.warehouseType,
            wkDate: this.dateSettingForm.wkDate.join(','),
            isBulkOil: this.dateSettingForm.isBulkOil
          }).then(() => {
            this.showDateSetting()
          })
        }
      })
    },
    deleteRow(pickupId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.yxcDeliveryOrder.deleteYxcPickupOrder, {
          pickupId
        }).then(() => {
          this.loadData()
        })
      })
    },
    showAdd() {
      this.$router.push('/ycdeliveryOrder/add?orderType=' + this.orderType)
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      let startDate = null
      let endDate = null
      if (this.dateArr && this.dateArr.length > 0) {
        startDate = this.dateArr[0]
        endDate = this.dateArr[1]
      }
      this.$axios.post(this.$apis.yxcDeliveryOrder.exportYxcPickupOrder, {
        ...this.searchForm,
        startDate,
        endDate
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    onEdit(row) {
      this.rowId = row.pickupId
      this.showEditDlg = true
    },
    onDown(pickupId) {
      return downloadPickupPdf(this.$apis.yxcDeliveryOrder.downloadPickupPdf, pickupId)
    },
    onAppoval(row) {
      this.currentPickupStatus = row.pickupStatus
      this.rowId = row.pickupId
      this.showDlg = true
    },
    loadUser() {
      this.$axios
        .get(this.$apis.system.selectSysUserByPage, { userType: '3' })
        .then(res => {
          this.userList = res.list || []
        })
    },
    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm,
        orderId: this.orderId || undefined,
        orderType: this.orderType
      }
      if (this.dateArr && this.dateArr.length > 0) {
        params.startDate = this.dateArr[0]
        params.endDate = this.dateArr[1]
      } else {
        params.startDate = undefined
        params.endDate = undefined
      }

      this.$axios
        .get(this.$apis.yxcDeliveryOrder.selectYxcPickupOrderByPageV2, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.dateArr = []
      this.$refs.formData.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="scss"></style>
